<template>
  <generic-container
    :title="$t('reports')"
    icon="list"
    ref="container"
    :searchable="true"
    :show_toggle="false"
    @filter="filterReports"
  >
    <!-- <div class="ui dividing header">{{ $t("reports") }}</div> -->
    <div class="ui list">
      <div
        class="item"
        v-for="(item, index) in reports_by_module"
        v-bind:key="index"
        @click="toggle(item, index)"
      >
        <i class="folder icon" v-bind:class="{ open: item.show_reports }"></i>
        <div class="content">
          <div class="header">{{ $t(item.module) }}</div>
          <div class="list" ref="report_list">
            <div
              class="item"
              v-bind:class="{ active: rpt == selected_report }"
              v-for="(rpt, idx) in item.reports"
              :key="idx"
              @click.stop="load_report(rpt)"
            >
              <i class="text file icon"></i>
              <div class="content">
                <div class="header">{{ rpt.name }}</div>
                <div class="description">{{ rpt.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import { local_api, clone } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "ReportList",
  components: { GenericContainer },
  filters: filters,
  data() {
    return {
      // reports_by_module: [],
      shown_reports: [],
      all_reports: [],
      loading: false,
      selected_report: undefined,
    };
  },
  computed: {
    reports_by_module() {
      let _r = this.shown_reports.map((m) => {
        m.show_reports = true;
        return m;
      });
      return _r;
    },
  },
  methods: {
    load_report(report) {
      this.$emit("load_report", report);
      this.selected_report = report;
      // this.$refs.container.toggle();
    },
    filterReports(value) {
      let filtered = this.all_reports.filter((r) => {
        let existsInModuleName = r.module.includes(value);
        let existsInReport = [];
        if (r.reports) {
          existsInReport = r.reports.filter((r) => {
            return r.description.includes(value) || r.name.includes(value);
          });
        }
        return existsInModuleName || existsInReport.length;
      });
      // console.log(filtered);
      this.shown_reports = filtered;
    },
    toggle(item, index) {
      item.show_reports = !item.show_reports;
      let vm = this;
      let trgt = vm.$refs.report_list[index];
      if (trgt) {
        window.jQuery(trgt).toggle("fast");
      }
    },
    init() {
      let vm = this;
      vm.loading = true;
      local_api(vm, "post", "/report_composer/do-get-all")
        .then((rpts) => {
          vm.loading = false;
          vm.shown_reports = rpts;
          vm.all_reports = clone(rpts);
          // let _r = reports_by_module.map((m) => {
          //   m.show_reports = true;
          //   return m;
          // });
          // this.reports_by_module = _r;
        })
        .catch((err) => {
          vm.loading = false;
          vm.$alertify.error(JSON.stringify(err, null, 2));
        });
    },
  },
  created() {
    let vm = this;
    vm.init();
  },
  mounted() {},
  watch: {
    loading() {
      this.$refs.container.set_loading(this.loading);
    },
  },
};
</script>

<style>
.active.item .content .header {
  color: #4183c4 !important;
}
</style>
